<p-panel header="{{'I18nValue.basicData' | hisUi}}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam>
		<textarea #content 
			hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.title"
			[(ngModel)]="researchInfrastructure.title" 
			class="textareaWidth100" rows="2"></textarea>
	</his-plam>
    
    <!-- #anchor dynamic field container -->    
    <ng-template #dynamicFieldContainer></ng-template>
    
    <his-plam>
        <p-autoComplete #content hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.language"
            [(ngModel)]="researchInfrastructure.language" hisEagerDataSource="language">
        </p-autoComplete>
    </his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam>
		<textarea #content 
			hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.description"
			[(ngModel)]="researchInfrastructure.description" rows="4"
			class="textareaWidth100">
		</textarea>
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam>
		<p-autoComplete #content 
			hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureType"
			[(ngModel)]="researchInfrastructure.researchInfrastructureType"
			hisEagerDataSource="researchInfrastructureTypeValue">
		</p-autoComplete>
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
	
	<his-plam>
		<p-autoComplete #content 
			hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureKind"
			[(ngModel)]="researchInfrastructure.researchInfrastructureKind"
			hisEagerDataSource="researchInfrastructureKindValue">
		</p-autoComplete>
	</his-plam>
	
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>
		
	<his-plam>	
		<p-autoComplete #content hisDdKey="fs.res.researchInfrastructure.ResearchInfrastructure.visibilityValue"
			[(ngModel)]="researchInfrastructure.visibilityValue" hisEagerDataSource="visibilityValue"
			(onClear)="onClear('visibilityValue')">
		</p-autoComplete>
	</his-plam>	
	<!-- #anchor dynamic field container -->   
    <ng-template #dynamicFieldContainer></ng-template>
    
	<res-infrastructure-accesskind-plam 
	researchInfrastructureAccessKindDdKey = "fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureAccessKinds"
	[(selectedInfrastructureAccesskinds)]="researchInfrastructure.researchInfrastructureAccessKinds"
	(selectedInfrastructureAccesskindsChange)= "onResearchInfrastructureAccesskindsChange($event)" ></res-infrastructure-accesskind-plam>
	 
	<!-- #anchor dynamic field container -->	
	<ng-template #dynamicFieldContainer></ng-template>

</p-panel>